import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const PATIENT_MGMT_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');

  .pm-root {
    padding: 24px;
    font-family: 'Outfit', sans-serif;
    color: #1e293b;
  }

  .pm-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(20px);
    padding: 32px 40px;
    border-radius: 32px;
    border: 1px solid #fff;
    box-shadow: 0 20px 50px rgba(186, 230, 253, 0.3);
    margin-bottom: 40px;
  }

  .pm-title { font-size: 32px; font-weight: 800; color: #0c4a6e; margin: 0; }
  .pm-subtitle { font-size: 14px; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: 1.5px; }

  /* ── Search Section ── */
  .pm-search-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
    max-width: 420px;
  }
  .pm-search-tabs {
    display: flex;
    gap: 8px;
  }
  .pm-search-tab {
    padding: 7px 20px;
    border-radius: 30px;
    border: 1.5px solid #e0f2fe;
    background: transparent;
    font-family: 'Outfit', sans-serif;
    font-size: 13px;
    font-weight: 700;
    color: #64748b;
    cursor: pointer;
    transition: all 0.25s ease;
  }
  .pm-search-tab:hover {
    border-color: #0ea5e9;
    color: #0284c7;
    background: #f0f9ff;
  }
  .pm-search-tab.active {
    background: linear-gradient(135deg, #0284c7, #0ea5e9);
    color: #fff;
    border-color: transparent;
    box-shadow: 0 4px 12px rgba(2, 132, 199, 0.25);
  }
  .pm-search-wrap {
    position: relative;
  }
  .pm-search-icon {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    pointer-events: none;
    color: #94a3b8;
  }
  .pm-search-input {
    width: 100%;
    padding: 12px 40px 12px 44px;
    border-radius: 14px;
    border: 1.5px solid #e0f2fe;
    background: rgba(240, 249, 255, 0.7);
    font-family: 'Outfit', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #0c4a6e;
    outline: none;
    transition: all 0.3s ease;
    box-sizing: border-box;
  }
  .pm-search-input::placeholder { color: #94a3b8; font-weight: 500; }
  .pm-search-input:focus {
    border-color: #0ea5e9;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 0 0 4px rgba(14, 165, 233, 0.12);
  }
  .pm-search-clear {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: #e0f2fe;
    border: none;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    font-size: 12px;
    color: #0284c7;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    transition: background 0.2s;
  }
  .pm-search-clear:hover { background: #bae6fd; }
  .pm-result-count {
    font-size: 12px;
    font-weight: 700;
    color: #0284c7;
    background: #e0f2fe;
    padding: 4px 12px;
    border-radius: 20px;
    white-space: nowrap;
  }

  /* ── Grid ── */
  .dl-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 24px;
    position: relative;
    z-index: 1;
  }

  /* ── Card ── */
  .dl-card-outer {
    position: relative;
    border-radius: 24px;
    padding: 2px;
    background: white;
    transition: all 0.4s cubic-bezier(.22,.68,0,1.2);
    box-shadow: 0 10px 30px rgba(186, 230, 253, 0.2);
  }
  .dl-card-outer:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(186, 230, 253, 0.4);
  }

  .dl-card-ring {
    position: absolute;
    inset: 0;
    border-radius: 24px;
    padding: 2px;
    background: conic-gradient(
      from var(--angle, 0deg),
      transparent 0deg,
      #0284c7 60deg,
      #7c3aed 120deg,
      #0ea5e9 180deg,
      transparent 240deg
    );
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    opacity: 0;
    transition: opacity 0.4s ease;
    pointer-events: none;
  }
  .dl-card-outer:hover .dl-card-ring {
    opacity: 1;
    animation: spin-light 2s linear infinite;
  }

  .dl-card-inner {
    background: #ffffff;
    border-radius: 22px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    height: 100%;
    border: 1px solid #f0f9ff;
    position: relative;
  }

  .pm-id-badge {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 11px;
    font-weight: 800;
    color: #64748b;
    background: #f1f5f9;
    padding: 4px 10px;
    border-radius: 8px;
  }

  .pm-name { font-size: 20px; font-weight: 800; color: #0c4a6e; margin-bottom: 8px; margin-top: 12px; }
  
  .pm-contact-row { display: flex; align-items: center; gap: 10px; font-size: 13px; color: #475569; margin-bottom: 6px; }
  .pm-contact-icon { width: 28px; height: 28px; border-radius: 8px; background: #f0f9ff; display: flex; align-items: center; justify-content: center; font-size: 12px; border: 1px solid #e0f2fe; }

  .pm-vitals-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-top: 12px; }
  .pm-vital-box { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 6px 10px; text-align: center; }
  .pm-vital-label { font-size: 10px; font-weight: 700; color: #94a3b8; text-transform: uppercase; }
  .pm-vital-val { font-size: 13px; font-weight: 800; color: #0f172a; margin-top: 2px; }

  .dl-divider { height: 1px; background: #f1f5f9; margin: 16px 0; }

  .pm-status-badge {
    font-size: 12px;
    font-weight: 700;
    padding: 8px 16px;
    border-radius: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    margin-bottom: 16px;
  }
  .pm-status-verified { color: #16a34a; background: #dcfce7; border: 1px solid #bbf7d0; }
  .pm-status-pending { color: #d97706; background: #fef3c7; border: 1px solid #fde68a; }

  .pm-btn-verify {
    width: 100%;
    padding: 12px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 800;
    cursor: pointer;
    transition: all 0.3s ease;
    background: linear-gradient(135deg, #0284c7, #0ea5e9);
    color: #fff;
    border: none;
    box-shadow: 0 4px 12px rgba(2, 132, 199, 0.2);
    margin-top: auto;
  }
  .pm-btn-verify:hover { 
    transform: translateY(-2px); 
    box-shadow: 0 8px 20px rgba(2, 132, 199, 0.3); 
    background: linear-gradient(135deg, #0ea5e9, #0284c7);
  }

  /* ── Modal ── */
  .pm-modal-overlay {
    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(15, 23, 42, 0.6);
    backdrop-filter: blur(4px);
    display: flex; justify-content: center; align-items: center;
    z-index: 1000;
  }
  .pm-modal {
    background: #fff;
    border-radius: 24px;
    width: 90%; max-width: 600px;
    max-height: 90vh; overflow-y: auto;
    padding: 32px;
    box-shadow: 0 25px 50px rgba(0,0,0,0.15);
  }
  .pm-form-grid {
    display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-top: 24px;
  }
  .pm-form-group { display: flex; flex-direction: column; gap: 6px; }
  .pm-form-group.full { grid-column: span 2; }
  .pm-label { font-size: 13px; font-weight: 700; color: #475569; }
  .pm-input { 
    padding: 12px 16px; border-radius: 12px; border: 1.5px solid #e2e8f0; 
    font-family: inherit; font-size: 14px; outline: none; transition: border 0.3s;
  }
  .pm-input:focus { border-color: #0ea5e9; box-shadow: 0 0 0 3px rgba(14,165,233,0.1); }
  .pm-modal-actions {
    display: flex; justify-content: flex-end; gap: 12px; margin-top: 32px;
  }
  .pm-btn-cancel {
    padding: 12px 24px; border-radius: 12px; background: #f1f5f9; color: #475569; font-weight: 700; cursor: pointer; border: none; transition: background 0.3s;
  }
  .pm-btn-cancel:hover { background: #e2e8f0; }
  
  .pm-btn-add-patient {
    background: linear-gradient(135deg, #10b981, #059669);
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 14px;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .pm-btn-add-patient:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4);
  }

  .pm-header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
  }

  /* ── Responsive Media Queries ── */
  @media (max-width: 1024px) {
    .pm-header {
      padding: 24px;
      gap: 16px;
    }
    .pm-title {
      font-size: 28px;
    }
  }

  @media (max-width: 768px) {
    .pm-root {
      padding: 16px;
    }
    .dl-grid { grid-template-columns: 1fr; }
    .pm-header {
      flex-direction: column;
      align-items: flex-start;
      padding: 20px;
      border-radius: 20px;
    }
    .pm-search-section {
      max-width: 100%;
      width: 100%;
    }
    .pm-header-actions {
      width: 100%;
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
    }
    .pm-btn-add-patient {
      justify-content: center;
      width: 100%;
    }
    .pm-title {
      font-size: 24px;
    }
    .pm-form-grid {
      grid-template-columns: 1fr;
    }
    .pm-form-group.full {
      grid-column: span 1;
    }
    .pm-modal {
      padding: 24px;
      width: 95%;
    }
    .pm-modal-actions {
      flex-direction: column;
      gap: 8px;
    }
    .pm-btn-cancel, .pm-btn-verify {
      width: 100% !important;
    }
  }

  @media (max-width: 480px) {
    .pm-search-tabs {
      flex-direction: column;
      gap: 8px;
    }
    .pm-search-tab {
      width: 100%;
      text-align: center;
    }
    .dl-grid {
      grid-template-columns: 1fr;
    }
    .pm-title {
      font-size: 22px;
    }
    .pm-modal {
      padding: 20px 16px;
    }
  }
`;

export default function Patients() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchType, setSearchType] = useState("name"); // "name" | "id"
  const [showAddModal, setShowAddModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [newPatient, setNewPatient] = useState({
    name: "", email: "", password: "", phone: "", city: "", address: "", dob: "", gender: "",
    height: "", weight: "", blood_group: "", blood_pressure: ""
  });

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${API}/api/users`);
      setUsers(res.data);
    } catch (err) {
      toast.error("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  const styleInjected = useRef(false);

  useEffect(() => {
    if (!styleInjected.current) {
      const tag = document.createElement("style");
      tag.textContent = PATIENT_MGMT_STYLES;
      document.head.appendChild(tag);
      styleInjected.current = true;
    }
    fetchUsers();
  }, []);

  const handleVerify = async (userId) => {
    const confirmVerify = window.confirm("Are you sure you want to verify this patient? This will generate a unique Patient ID.");
    if (!confirmVerify) return;

    const year = new Date().getFullYear();
    const randomNum = Math.floor(1000 + Math.random() * 9000);
    const uniqueId = `PT-${year}-${randomNum}`;

    try {
      await axios.put(`${API}/api/users/${userId}/verify`, {
        patient_unique_id: uniqueId
      });
      toast.success(`Patient Verified! Assigned ID: ${uniqueId}`);
      fetchUsers();
    } catch (err) {
      toast.error("Failed to verify patient");
    }
  };

  const handleAddPatient = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const res = await axios.post(`${API}/api/users/add`, newPatient);
      toast.success("Patient account created! ID: " + res.data.patient_unique_id);
      setShowAddModal(false);
      setNewPatient({ name: "", email: "", password: "", phone: "", city: "", address: "", dob: "", gender: "", height: "", weight: "", blood_group: "", blood_pressure: "" });
      fetchUsers();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to create patient");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPatient((prev) => ({ ...prev, [name]: value }));
  };

  const filteredUsers = users.filter((u) => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return true;
    if (searchType === "name") {
      return u.name && u.name.toLowerCase().includes(q);
    }
    // id: match numeric db id OR patient unique id (e.g. PT-2026-1234)
    return (
      String(u.id).includes(q) ||
      (u.patient_unique_id && u.patient_unique_id.toLowerCase().includes(q))
    );
  });

  return (
    <div className="pm-root">
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Header */}
      <div className="pm-header">
        <div>
          <p className="pm-subtitle">Network Stewardship</p>
          <h1 className="pm-title">Patient Registry</h1>
        </div>

        {/* Search Section */}
        <div className="pm-search-section">
          {/* Type selector */}
          <div className="pm-search-tabs">
            <button
              className={`pm-search-tab ${searchType === "name" ? "active" : ""}`}
              onClick={() => { setSearchType("name"); setSearchQuery(""); }}
            >
              👤 By Name
            </button>
            <button
              className={`pm-search-tab ${searchType === "id" ? "active" : ""}`}
              onClick={() => { setSearchType("id"); setSearchQuery(""); }}
            >
              🪪 By ID
            </button>
          </div>
          {/* Input */}
          <div className="pm-search-wrap">
            <span className="pm-search-icon">🔍</span>
            <input
              id="patient-search"
              type="text"
              className="pm-search-input"
              placeholder={searchType === "name" ? "Enter patient name…" : "Enter patient ID…"}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchQuery && (
              <button className="pm-search-clear" onClick={() => setSearchQuery("")}>✕</button>
            )}
          </div>
        </div>

        <div className="pm-header-actions">
          {searchQuery && (
            <span className="pm-result-count">{filteredUsers.length} result{filteredUsers.length !== 1 ? 's' : ''}</span>
          )}
          <button className="pm-btn-add-patient" onClick={() => setShowAddModal(true)}>
            <span>+</span> Add Patient
          </button>
        </div>
      </div>

      {/* Grid Layout */}
      {loading ? (
        <div style={{ padding: '80px', textAlign: 'center', fontWeight: 800, color: '#0284c7', animation: 'pulse 2s infinite' }}>Syncing Member Data...</div>
      ) : users.length === 0 ? (
        <div style={{ padding: '80px', textAlign: 'center', opacity: 0.5 }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🩺</div>
          <p style={{ fontWeight: 800, fontSize: '18px' }}>No Patients Registered</p>
        </div>
      ) : filteredUsers.length === 0 ? (
        <div style={{ padding: '80px', textAlign: 'center', opacity: 0.6 }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔍</div>
          <p style={{ fontWeight: 800, fontSize: '18px', color: '#0c4a6e' }}>No patients match "{searchQuery}"</p>
          <p style={{ fontSize: '14px', color: '#64748b', marginTop: '8px' }}>Try a different name or ID.</p>
        </div>
      ) : (
        <div className="dl-grid">
          {filteredUsers.map((user) => (
            <div key={user.id} className="dl-card-outer">
              <div className="dl-card-ring" />
              <div className="dl-card-inner">
                <span className="pm-id-badge">ID: {user.id}</span>

                <h2 className="pm-name">{user.name}</h2>

                <div className="pm-contact-row">
                  <span className="pm-contact-icon">📧</span>
                  <span style={{ fontWeight: 600 }}>{user.email}</span>
                </div>
                <div className="pm-contact-row">
                  <span className="pm-contact-icon">📞</span>
                  <span>{user.phone || "No phone linked"}</span>
                </div>
                <div className="pm-contact-row">
                  <span className="pm-contact-icon">📍</span>
                  <span style={{ fontWeight: 700 }}>{user.city || "Remote"}</span>
                </div>

                {(user.height || user.weight || user.blood_group || user.blood_pressure) && (
                  <div className="pm-vitals-grid">
                    <div className="pm-vital-box">
                      <div className="pm-vital-label">Height</div>
                      <div className="pm-vital-val">{user.height || "-"}</div>
                    </div>
                    <div className="pm-vital-box">
                      <div className="pm-vital-label">Weight</div>
                      <div className="pm-vital-val">{user.weight || "-"}</div>
                    </div>
                    <div className="pm-vital-box">
                      <div className="pm-vital-label">Blood</div>
                      <div className="pm-vital-val">{user.blood_group || "-"}</div>
                    </div>
                    <div className="pm-vital-box">
                      <div className="pm-vital-label">BP</div>
                      <div className="pm-vital-val">{user.blood_pressure || "-"}</div>
                    </div>
                  </div>
                )}

                <div className="dl-divider" />

                {user.is_verified ? (
                  <div className="pm-status-badge pm-status-verified">
                    ✓ Verified ({user.patient_unique_id})
                  </div>
                ) : (
                  <div className="pm-status-badge pm-status-pending">
                    ● Pending Verification
                  </div>
                )}

                <div style={{ marginTop: 'auto' }}>
                  {!user.is_verified ? (
                    <button onClick={() => handleVerify(user.id)} className="pm-btn-verify">
                      Verify Patient
                    </button>
                  ) : (
                    <div style={{ textAlign: 'center', fontSize: '12px', color: '#64748b', fontWeight: 700, fontStyle: 'italic', padding: '12px' }}>
                      Record Validated
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Add Patient Modal */}
      {showAddModal && (
        <div className="pm-modal-overlay">
          <div className="pm-modal">
            <h2 className="pm-title" style={{ fontSize: '24px' }}>Add New Patient</h2>
            <p className="pm-subtitle" style={{ fontSize: '12px', marginTop: '4px' }}>Create an account manually</p>
            
            <form onSubmit={handleAddPatient}>
              <div className="pm-form-grid">
                <div className="pm-form-group full">
                  <label className="pm-label">Full Name *</label>
                  <input required type="text" name="name" className="pm-input" value={newPatient.name} onChange={handleInputChange} placeholder="John Doe" />
                </div>
                
                <div className="pm-form-group">
                  <label className="pm-label">Email Address *</label>
                  <input required type="email" name="email" className="pm-input" value={newPatient.email} onChange={handleInputChange} placeholder="john@example.com" />
                </div>
                <div className="pm-form-group">
                  <label className="pm-label">Password *</label>
                  <input required type="text" name="password" className="pm-input" value={newPatient.password} onChange={handleInputChange} placeholder="Temporary password" />
                </div>

                <div className="pm-form-group">
                  <label className="pm-label">Phone Number</label>
                  <input type="tel" name="phone" className="pm-input" value={newPatient.phone} onChange={handleInputChange} placeholder="+1 234 567 890" />
                </div>
                <div className="pm-form-group">
                  <label className="pm-label">Date of Birth</label>
                  <input type="date" name="dob" className="pm-input" value={newPatient.dob} onChange={handleInputChange} />
                </div>

                <div className="pm-form-group">
                  <label className="pm-label">Gender</label>
                  <select name="gender" className="pm-input" value={newPatient.gender} onChange={handleInputChange}>
                    <option value="">Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div className="pm-form-group">
                  <label className="pm-label">City</label>
                  <input type="text" name="city" className="pm-input" value={newPatient.city} onChange={handleInputChange} placeholder="City Name" />
                </div>

                <div className="pm-form-group full">
                  <label className="pm-label">Full Address</label>
                  <input type="text" name="address" className="pm-input" value={newPatient.address} onChange={handleInputChange} placeholder="123 Main St, Apt 4" />
                </div>

                <div className="pm-form-group">
                  <label className="pm-label">Height (cm)</label>
                  <input type="number" name="height" className="pm-input" value={newPatient.height} onChange={handleInputChange} placeholder="175" />
                </div>
                <div className="pm-form-group">
                  <label className="pm-label">Weight (kg)</label>
                  <input type="number" name="weight" className="pm-input" value={newPatient.weight} onChange={handleInputChange} placeholder="70" />
                </div>

                <div className="pm-form-group">
                  <label className="pm-label">Blood Group</label>
                  <select name="blood_group" className="pm-input" value={newPatient.blood_group} onChange={handleInputChange}>
                    <option value="">Select</option>
                    <option value="A+">A+</option>
                    <option value="A-">A-</option>
                    <option value="B+">B+</option>
                    <option value="B-">B-</option>
                    <option value="AB+">AB+</option>
                    <option value="AB-">AB-</option>
                    <option value="O+">O+</option>
                    <option value="O-">O-</option>
                  </select>
                </div>
                <div className="pm-form-group">
                  <label className="pm-label">Blood Pressure</label>
                  <input type="text" name="blood_pressure" className="pm-input" value={newPatient.blood_pressure} onChange={handleInputChange} placeholder="120/80" />
                </div>
              </div>

              <div className="pm-modal-actions">
                <button type="button" className="pm-btn-cancel" onClick={() => setShowAddModal(false)}>Cancel</button>
                <button type="submit" className="pm-btn-verify" style={{ width: 'auto', marginTop: 0 }} disabled={isSubmitting}>
                  {isSubmitting ? "Creating..." : "Create Patient"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}